module.exports = __webpack_public_path__ + "static/media/wearable.9ce91173.png";